import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { ACCEPTABLE_PROOF_OF_ADDRESS_DOCUMENT_KEYS } from "../../constants/workerOnboarding";

export function ProofOfAddressAcceptableContent({
  className = "",
  showIntro = true,
}) {
  const { t } = useTranslation();

  return (
    <div className={["text-start", className].filter(Boolean).join(" ")}>
      {showIntro && <div>{t("proofOfAddressAcceptableIntro")}</div>}
      <ul className={`mb-0 ps-3${showIntro ? " mt-1" : ""}`}>
        {ACCEPTABLE_PROOF_OF_ADDRESS_DOCUMENT_KEYS.map((key) => (
          <li key={key}>{t(key)}</li>
        ))}
      </ul>
    </div>
  );
}

ProofOfAddressAcceptableContent.propTypes = {
  className: PropTypes.string,
  showIntro: PropTypes.bool,
};

export default function ProofOfAddressAcceptableInlineHint({ className = "mb-1" }) {
  return (
    <div
      className={["text-muted small d-block", className].filter(Boolean).join(" ")}
    >
      <ProofOfAddressAcceptableContent />
    </div>
  );
}

ProofOfAddressAcceptableInlineHint.propTypes = {
  className: PropTypes.string,
};
